import type { ReceiptChannel } from '@chukua/common';

export interface ReferenceHint {
  label: string;
  hint: string;
  isRequired: boolean;
}

/**
 * Guidance only. The format and the duplicate check belong to the API's payment-reference rule for the channel, which stays the
 * authority; mirroring its regexes here would let the two drift apart, so the form only knows whether a reference is needed at all.
 */
const REFERENCE_HINTS: Record<ReceiptChannel, ReferenceHint> = {
  mpesa: { label: 'M-Pesa code', hint: '10 letters or digits, e.g. QGH7K2L9PA', isRequired: true },
  cheque: { label: 'Cheque number', hint: 'The cheque number, digits only', isRequired: true },
  bank_transfer: { label: 'Bank reference', hint: 'Optional. Copy it from the statement if it has one', isRequired: false },
};

export function referenceHintFor(channel: ReceiptChannel): ReferenceHint {
  return REFERENCE_HINTS[channel];
}
